import React, { useState, useEffect } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "./Testimonials.scss";

import ribeiro from "../../assets/images/people/Ribeiro.jpg";
import oliva from "../../assets/images/people/Oliva.jpg";
import leila from "../../assets/images/people/Leila.jpg";
import maira from "../../assets/images/people/Maira.jpg";
import amorim from "../../assets/images/people/Amorim.jpg";
import geiziane from "../../assets/images/people/Geiziane.jpg";
import isadora from "../../assets/images/people/Isadora.jpg";
import samira from "../../assets/images/people/Samira.jpg";
import dorow from "../../assets/images/people/Ana.jpg";

interface Testimonial {
  avatar: string;
  name: string;
  text: string;
  job: string;
}

const testimonials: Testimonial[] = [
  {
    avatar: ribeiro,
    name: "Ana Carolina Ribeiro",
    text: `Minha sessão foi uma experiência mágica!<br/>
           Senti um relaxamento imediato e profundo, uma conexão com meu eu interior e um aumento da intuição.<br/>
           Indico esse trabalho para qualquer pessoa que precise de equilíbrio físico e mental.`,
    job: "Representante Comercial",
  },
  {
    avatar: oliva,
    name: "Stephanie Oliva",
    text: `A sessão de liberação miofascial e o pós foi como estar no paraíso!<br/>
           Tenho fibromialgia e dores constantes, principalmente na cervical, que causam crises de enxaqueca.<br/>
           Depois da sessão, passei dias melhores. Que trabalho impecável! 🧡`,
    job: "Biomédica",
  },
  {
    avatar: leila,
    name: "Leila Nones",
    text: `Todas as experiências que tive foram transformadoras.<br/>
           As conversas são conduzidas com muita sensibilidade, criando um espaço seguro para enxergar o que nem imaginávamos precisar olhar.<br/>
           E para completar, uma massagem maravilhosa e o toque amoroso do Reiki.<br/>
           Recomendo demais! ♥`,
    job: "Empreendedora e Instrutora de Yoga",
  },
  {
    avatar: maira,
    name: "Joice Maíra",
    text: `Minha experiência com a massagem bioenergética e o Reiki foi transformadora.<br/>
           Desde o acolhimento até o atendimento personalizado, senti um cuidado profundo.<br/>
           Existe uma energia que vai além da técnica. Saio sempre renovada e recomendo muito!`,
    job: "Doula",
  },
  {
    avatar: amorim,
    name: "Ana Amorim",
    text: `O atendimento é simplesmente incrível!<br/>
           Muita atenção, cuidado e dedicação. Gostei de todas as terapias realizadas.<br/>
           O diferencial está no cuidado além das sessões, com orientações que fizeram toda a diferença.<br/>
           Um trabalho completo 🤍`,
    job: "Publicitária",
  },
  {
    avatar: geiziane,
    name: "Geiziane Pereira",
    text: `Minha sessão de Reiki e Cone Hindu foi muito agradável e relaxante.<br/>
           Senti uma paz e leveza na alma. Super indico esse trabalho!`,
    job: "Comercial",
  },
  {
    avatar: isadora,
    name: "Isadora Mestais",
    text: `Trabalho excelente! Cada pessoa é vista de forma única, com aplicação do melhor tratamento.<br/>
           Um atendimento que nos faz sentir confortáveis e acolhidas.<br/>
           Recomendo inúmeras vezes!`,
    job: "Storymaker",
  },
  {
    avatar: samira,
    name: "Samira Geissler",
    text: `Simplesmente transformador!<br/>
           É maravilhoso ser atendida na totalidade.<br/>
           Estou melhorando a cada dia. Super recomendo!`,
    job: "Empreendedora",
  },
  {
    avatar: dorow,
    name: "Ana Carolina Dorow",
    text: `É um trabalho simplesmente incrível!<br/>
           Um atendimento completo, com todos os cuidados para que possamos nos entregar ao tratamento.`,
    job: "Florista",
  },
];

const Testimonials: React.FC = () => {
  const [slidesToShow, setSlidesToShow] = useState(1);

  useEffect(() => {
    const handleResize = () => {
      const width = window.innerWidth;
      if (width >= 1024) {
        setSlidesToShow(3);
      } else if (width >= 768) {
        setSlidesToShow(2);
      } else {
        setSlidesToShow(1);
      }
    };

    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const settings = {
    autoplay: true,
    autoplaySpeed: 5000,
    pauseOnHover: true,
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow,
    slidesToScroll: 1,
    prevArrow: <div className="slick-prev">&#10094;</div>,
    nextArrow: <div className="slick-next">&#10095;</div>,
  };

  return (
    <section className="testimonials" id="testimonials">
      <div className="testimonialsPage" data-aos="fade-up">
        <h2>Depoimentos</h2>
        <div
          className="slider-container"
          data-aos="zoom-out-up"
          data-aos-anchor-placement="bottom-bottom"
        >
          <Slider {...settings}>
            {testimonials.map((testimonial, index) => (
              <div key={index} className="testimonial">
                <img
                  src={testimonial.avatar}
                  alt={testimonial.name}
                  className="avatar"
                />
                <p
                  className="text"
                  dangerouslySetInnerHTML={{ __html: testimonial.text }}
                />
                <p className="name">{testimonial.name}</p>
                <p className="job">{testimonial.job}</p>
              </div>
            ))}
          </Slider>
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
